import type { ComponentProps } from "react"

export default function Address(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="15"
      height="13"
      viewBox="0 0 15 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M7.16602 7.16667V12.5M7.16602 0.5V2.5M11.166 2.5C11.5109 2.50016 11.8423 2.63398 12.0907 2.87333L13.6287 4.35333C13.6932 4.41552 13.7445 4.49008 13.7796 4.57255C13.8146 4.65503 13.8327 4.74372 13.8327 4.83333C13.8327 4.92295 13.8146 5.01164 13.7796 5.09411C13.7445 5.17659 13.6932 5.25114 13.6287 5.31333L12.0907 6.79333C11.8423 7.03269 11.5109 7.1665 11.166 7.16667H3.16602C2.82111 7.1665 2.48968 7.03269 2.24135 6.79333L0.704017 5.31333C0.639496 5.25114 0.588174 5.17659 0.553121 5.09411C0.518067 5.01164 0.5 4.92295 0.5 4.83333C0.5 4.74372 0.518067 4.65503 0.553121 4.57255C0.588174 4.49008 0.639496 4.41552 0.704017 4.35333L2.24135 2.87333C2.48968 2.63398 2.82111 2.50016 3.16602 2.5H11.166Z"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
